export const clientPaths = {
  absolute: '/:clientId/clients',

  sso: {
    absolute: '/:clientId/clients/sso',
    relative: 'sso',
  },
} as const;
